export default __webpack_public_path__ + "static/media/partner.6d164ad2.png";